import type { IconData } from '@stacksjs/iconify-core'

export const cloudThunder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 14a1 1 0 0 1 0-2a5 5 0 1 0-4.6-6.965l-.72 1.686l-1.742-.572A3 3 0 1 0 5 12h2a1 1 0 0 1 0 2H5a5 5 0 1 1 1.561-9.751A7.002 7.002 0 0 1 20 7a7 7 0 0 1-7 7m-2.29-2.936c.519.198.787.801.598 1.346L9.94 16.36c-.19.545-.763.826-1.282.627s-.786-.801-.597-1.346l1.368-3.95c.188-.545.762-.826 1.281-.627m1.632 3.949c.519.198.786.801.597 1.346l-1.368 3.95c-.188.545-.762.826-1.281.627s-.787-.801-.598-1.346l1.368-3.95c.19-.545.763-.826 1.282-.627M9 14.949h3c.552 0 1 .47 1 1.051c0 .58-.448 1.05-1 1.05H9c-.552 0-1-.47-1-1.05s.448-1.05 1-1.05z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default cloudThunder
